import { render } from "./AddBanner.vue?vue&type=template&id=2a9263ea&scoped=true"
import script from "./AddBanner.vue?vue&type=script&lang=js"
export * from "./AddBanner.vue?vue&type=script&lang=js"

import "./AddBanner.vue?vue&type=style&index=0&id=2a9263ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9263ea"]])

export default __exports__